import axiosInstance from "../../../Axios/Axios"

const getAllBAU=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
return await axiosInstance.get(`Index/GetAllIndexManagmentByTenantId?tenantId=${tenantId}&periodId=${periodId}`)
}

const getBAUDetail=async({queryKey}:any)=>{
    let id=queryKey[1];
return await axiosInstance.get(`Index/GetIndexManagmentDetailById?id=${id}`)
}

const getAllCategory=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetAllCategoriesTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}

const getBank=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetBank?tenantId=${tenantId}`)
}

const createIndexManaging=async(Data:any)=>{
return await axiosInstance.post('/Index/AddIndexManaging',Data)
}

const EditIndexManaging=async(Data:any)=>{
    return await axiosInstance.post('/Index/EditIndexManaging',Data)
    }

const editIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/EditIndex',Data)
}

const getAllCategoriesTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/Index/GetAllCategoriesTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=50000`)
}

const addCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/AddCategory',Data)
}

const editCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/EditCategory',Data)
}

const getAllMyTeamByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let teamId=queryKey[2];
    return await axiosInstance.get(`/Team/GetAllMyTeamByTenantId?tenantId=${tenantId}&teamId=${teamId}`)
}

const getAlBrothersByTeamId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/Team/GetAlBrothersByTeamId?teamId=${tenantId}`)
}

const getAllTeamsByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`/Team/GetAllTeamByTenantId?tenantId=${tenantId}`)
}

const getAllObjectivesByPeriodId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetAllObjectivesByPeriodId?tenantId=${tenantId}&periodId=${periodId}`)
}

const getAllKeyResyltByTeamId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    let teamId=queryKey[3];
    return await axiosInstance.get(`/OKR/GetAllKeyResyltByTeamId?tenantId=${tenantId}&periodId=${periodId}&teamId=${teamId}`)
}

const getAllKeyResyltByPersonId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetAllKeyResyltByPersonId?tenantId=${tenantId}&periodId=${periodId}`)
}
// const getIndexDetail=async(Data:any)=>{
//     return await axiosInstance.post('/Index/GetIndexDetail',Data)
// }

const getIndexDetail=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
return await axiosInstance.get(`Index/GetIndexDetail?id=${tenantId}`)
}

const deleteCategory=async(Data:any)=>{
    return await axiosInstance.post('/Index/DeleteCategory',Data)
}

const deleteIndexManaging=async(Data:any)=>{
    return await axiosInstance.post('/Index/DeleteIndexManaging',Data)
}

const deleteIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/Delete',Data)
}

const acceptIndex=async(Data:any)=>{
    return await axiosInstance.post('/Index/AcceptIndex',Data)
}

const GetAllOKRStateByTenantId = async ({ queryKey }: any) => {
    let tenantId = queryKey[1];
    return await axiosInstance.get(
      `/OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`
    );
  };

  const getAllObjectiveDefinitionLevelByTenantId = async ({ queryKey }: any) => {
    let tenantId: string | null = queryKey[1];
    return await axiosInstance.get(
      `OKR/getAllDefinitionLevelByTenantId?tenantId=${tenantId}`
    );
  };
   
  const getAllReportingPeriodByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`Index/GetAllReportingPeriodByTenantId?tenantId=${tenantId}`)
}

const getAllMeasurementUnitByTenantId=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    return await axiosInstance.get(`Index/GetAllMeasurementUnitByTenantId?tenantId=${tenantId}`)
}

export {
    getAllBAU,
    getAllCategoriesTenantId,
    createIndexManaging,
    EditIndexManaging,
    getIndexDetail,
    editIndex,
    deleteCategory,
    getAllReportingPeriodByTenantId,
    getAllMeasurementUnitByTenantId,
    getAllCategory,
    addCategory,
    getAllKeyResyltByTeamId,
    getBank,
    editCategory,
    getAllObjectivesByPeriodId,
    acceptIndex,
    deleteIndexManaging,
    getAllKeyResyltByPersonId,
    deleteIndex,
    getBAUDetail,
    getAllObjectiveDefinitionLevelByTenantId,
    GetAllOKRStateByTenantId,
    getAllMyTeamByTenantId,
    getAllTeamsByTenantId,
    getAlBrothersByTeamId
}